export class LogEventCodes {

    public static SUCCESSFUL_SETUP_CODE: number = 100;
    public static SUCCESSFUL_LOGIN_CODE: number = 200;
    public static UNSUCCESSFUL_LOGIN_CODE: number = 220;
    public static CUSTOMER_CHANGED_PASSWORD_CODE: number = 240;
    public static CUSTOMER_CHANGED_USERID_CODE: number = 260;
    public static CUSTOMER_ACCESS_DISABLED_CODE: number = 280;
    public static CUSTOMER_TEMP_PASSWORD_EXPIRED_CODE: number = 290;    
    public static CUSTOMER_VIEWED_STATEMENT_CODE: number = 400;
    public static CUSTOMER_DOWNLOADED_STATEMENT_CODE: number = 410;
    public static CUSTOMER_PRINTED_STATEMENT_CODE: number = 420;
    public static CUSTOMER_VIEWED_CONFIRMATION_CODE: number = 300;
    public static CUSTOMER_DOWNLOADED_CONFIRMATION_CODE: number = 310;
    public static CUSTOMER_PRINTED_CONFIRMATION_CODE: number = 320;
    public static CUSTOMER_VIEWED_SUMMARY_CODE: number = 500;
    public static CUSTOMER_DOWNLOADED_SUMMARY_CODE: number = 510;
    public static CUSTOMER_PRINTED_SUMMARY_CODE: number = 520; 
    public static CUSTOMER_SIGNED_EDOCUMENT_CODE: number = 600;    
    public static CUSTOMER_CANCELLED_EDOCUMENT_CODE: number = 610;    
}
